import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row py-5 bg-main" }
const _hoisted_3 = { class: "col-12 col-sm-6 order-2 order-sm-1" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 col-sm-10 offset-sm-2" }
const _hoisted_6 = { class: "col-12 col-sm-6 order-1 order-sm-2 color-light-black-n-dark-white" }
const _hoisted_7 = {
  class: "d-flex flex-column justify-content-center h-100 align-items-center",
  style: {"min-height":"25vh"}
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "d-flex justify-content-center my-3" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "d-flex justify-content-center mt-2 mb-3" }
const _hoisted_12 = {
  href: "https://github.com/porterwilcox",
  target: "_blank",
  style: {"width":"30px","height":"30px","border-radius":"10%"},
  class: "c-pointer text-decoration-none color-light-black-n-dark-white d-flex justify-content-center align-items-center icon-border"
}
const _hoisted_13 = {
  href: "https://linkedin.com/in/porterajeti",
  target: "_blank",
  style: {"width":"30px","height":"30px","border-radius":"10%"},
  class: "c-pointer text-decoration-none color-light-black-n-dark-white d-flex justify-content-center align-items-center icon-border mx-2 mx-lg-3"
}
const _hoisted_14 = {
  href: "https://firebasestorage.googleapis.com/v0/b/ajeti-portfolio.firebasestorage.app/o/PorterAjeti.pdf?alt=media",
  target: "_blank",
  style: {"width":"30px","height":"30px","border-radius":"10%"},
  class: "c-pointer text-decoration-none color-light-black-n-dark-white d-flex justify-content-center align-items-center icon-border"
}
const _hoisted_15 = { class: "d-flex justify-content-center mb-3 mb-sm-0" }
const _hoisted_16 = { class: "form-check form-switch mb-3" }
const _hoisted_17 = ["checked"]
const _hoisted_18 = { class: "row bg-comp pb-5" }
const _hoisted_19 = { class: "col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-xl-6 offset-xl-3 mb-5" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = ["href"]
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = {
  class: "pb-4 text-center",
  style: {"max-width":"200px"}
}
const _hoisted_25 = { class: "mx-3 text-center d-sm-none" }
const _hoisted_26 = {
  key: 0,
  class: "col-8 offset-2 col-sm-6 offset-sm-3 mt-4 mt-sm-5 pt-3 pt-sm-5 pb-0 pb-sm-2"
}

import { ref } from 'vue'
import CrossWordCmp from '@/components/CrossWordCmp.vue'
import { useState } from '@/state'



export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const settingsState = useState().settingsState;

const projectCategories = ref([
  {
    name: "Games",
    description: "I've been captivated by the power of creating tools and games since I started learning how to code and clumsily built a <a href='https://porterwilcox.github.io/chess-clock/' target='_blank'>chess clock</a> (after one week of learning) and a <a href='https://porterwilcox.github.io/matching-game/' target='_blank'>sequence memorization game</a> (after a couple more). <br /><br /> In the fall of 2024, the idea for a game inspired by NYT Connections popped into my head and Stacked was created. The excitement and fulfillment I get in seeing thousands of puzzlers play every day has ignited my passion for creating fun daily word games.",
    projects: [
      {
        name: "Stacked",
        description:
          "Uncover hidden connections in Stacked! This daily word game challenges you to group words into 1, 2, 3, 4, and 5-word categories.",
        link: "https://stacked.clevergoat.com",
        image:
          "https://firebasestorage.googleapis.com/v0/b/connectionsstacked.appspot.com/o/stacked-logo.png?alt=media",
        side: 0,
      },
      {
        name: "Antonymz",
        description:
          "Test your vocabulary with Antonymz! Use semantic clues and AI hints to find two hidden words that are perfect opposites.",
        link: "https://antonymz.web.app",
        image:
          "https://firebasestorage.googleapis.com/v0/b/antonymz-e833f.firebasestorage.app/o/antonymz-logo-1200x600.png?alt=media",
        side: 1,
      },
    ],
  },
  {
    name: "Professional",
    description: "I've worked in the software industry as an engineer, an instructor, and a consultant. I've taught full stack web development courses at a local coding bootcamp, and I've led teams in developing native mobile and desktop applications, API's, and web applications. <br /><br /> I'm currently a software engineer at <a href='https://clevergoat.com' target='_blank'>clevergoat.com</a> 🐐",
    projects: [
      {
        name: "Rjourney",
        description:
          "Development lead for Rjourney's customer-facing portal enabling tens of thousands of RV campers to book stays, alongside the BookingAPI that powers 3rd-party OTA integrations.",
        link: "https://rjourney.com/",
        image:
          "https://firebasestorage.googleapis.com/v0/b/ajeti-portfolio.firebasestorage.app/o/rjourney-logo.png?alt=media",
        side: 0,
      },
      {
        name: "AgentCubed",
        description: "Primary developer for an agent-facing health insurance mobile application. AgentCubed harnesses Angular and Ionic to deploy to both web and native mobile apps with a single codebase. It features action prompt push notifications, file uploads, meeting reminders, and more helpful tools.",
        link: "https://play.google.com/store/apps/details?id=com.agentcubed.mobile&hl=en_US",
        image: "https://firebasestorage.googleapis.com/v0/b/ajeti-portfolio.firebasestorage.app/o/agent-cubed-logo.webp?alt=media",
        side: 1,
      },
      {
        name: "Kayak Chile",
        description:
          "During my whitewater kayaking adventure in Chile (2019-2020), I used my web development skills to support the trip, contributing to Kayak Chile’s online presence.",
        link: "https://kayakchile.net",
        image:
          "https://firebasestorage.googleapis.com/v0/b/ajeti-portfolio.firebasestorage.app/o/kayak-chile-logo.jpg?alt=media",
        side: 0,
      },
    ],
  },
  {
    name: "Education",
    description: "I'm pursuing a master's degree in computer science and an AI graduate certificate from CU Boulder. I'm learning the theory and concepts of machine learning and advanced computer algorithms that will later enable me to implement these tools in real-world applications.",
    projects: [
      {
        name: "ML: Supervised Learning Final",
        description:
        "A deep dive into supervised learning models including Logistic Regression, Random Forest, and Gradient Boosting, with real-world applications.",
        link: "https://github.com/porterwilcox/supervised-learning",
        image:
        "https://firebasestorage.googleapis.com/v0/b/ajeti-portfolio.firebasestorage.app/o/github-logo.png?alt=media",
        side: 1,
      },
      {
        name: "News Sentiment Analyzer",
        description:
          "A tool that analyzes sentiment in news headlines, leveraging AI-driven natural language processing to classify news sentiment trends.",
        link: "https://newssentimentanalyzer.web.app/",
        image:
          "https://github.com/porterwilcox/news-sentiment-analyzer/blob/main/web-app/public/img/icons/windows11/LargeTile.scale-200.png?raw=true",
        side: 0,
      },
    ],
  },
]);

const porfolioAvatarImgs = ref([
  'https://firebasestorage.googleapis.com/v0/b/ajeti-portfolio.firebasestorage.app/o/portfolio-avatar-1.jpeg?alt=media',
  'https://firebasestorage.googleapis.com/v0/b/ajeti-portfolio.firebasestorage.app/o/portfolio-avatar-2.jpeg?alt=media',
  'https://firebasestorage.googleapis.com/v0/b/ajeti-portfolio.firebasestorage.app/o/portfolio-avatar-3.jpeg?alt=media',
  'https://firebasestorage.googleapis.com/v0/b/ajeti-portfolio.firebasestorage.app/o/portfolio-avatar-4.jpeg?alt=media',
  'https://firebasestorage.googleapis.com/v0/b/ajeti-portfolio.firebasestorage.app/o/portfolio-avatar-5.jpeg?alt=media',
]);

let profileIntervalId: any;
const resetPortfolioImgInterval = () => {
  if (profileIntervalId) {
    clearInterval(profileIntervalId);
  }
  profileIntervalId = setInterval(() => {
    let next = portfolioImgIndex.value % porfolioAvatarImgs.value.length + 1;
    next = next == porfolioAvatarImgs.value.length ? 0 : next;
    portfolioImgIndex.value = next;
  }, 4500);
}
const portfolioImgIndex = ref(0);
resetPortfolioImgInterval();

const swipePortfolioImgLeft = () => swipePortfolioImg(1);
const swipePortfolioImgRight = () => swipePortfolioImg(-1);

const swipePortfolioImg = (shift: number) => {
  let next = portfolioImgIndex.value + shift;
  if (next == -1) {
    next = porfolioAvatarImgs.value.length - 1;
  } else if (next == porfolioAvatarImgs.value.length) {
    next = 0;
  }
  portfolioImgIndex.value = next;
  resetPortfolioImgInterval();
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(CrossWordCmp)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(porfolioAvatarImgs.value, (src, i) => {
              return _withDirectives((_openBlock(), _createElementBlock("img", {
                key: 'portfolio-img-' + i,
                style: {"width":"200px","height":"200px","border-radius":"50%","min-width":"45%","min-height":"45%"},
                src: porfolioAvatarImgs.value[i],
                alt: "portfolio-avatar",
                class: _normalizeClass({ 'd-none': i != portfolioImgIndex.value })
              }, null, 10, _hoisted_8)), [
                [
                  _directive_touch,
                  swipePortfolioImgLeft,
                  "swipe",
                  { left: true }
                ],
                [
                  _directive_touch,
                  swipePortfolioImgRight,
                  "swipe",
                  { right: true }
                ]
              ])
            }), 128)),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(porfolioAvatarImgs.value, (_, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'marker-' + i,
                  class: _normalizeClass([{ 'me-1': i == 0, 'mx-1': (i != 0 && i != porfolioAvatarImgs.value.length), 'ms-1': i == porfolioAvatarImgs.value.length, 'bg-primary': i == portfolioImgIndex.value, 'bg-comp': i != portfolioImgIndex.value }, "c-pointer"]),
                  style: {"width":"15px","height":"15px","border-radius":"50%"},
                  onClick: ($event: any) => {portfolioImgIndex.value = i; resetPortfolioImgInterval()}
                }, null, 10, _hoisted_10))
              }), 128))
            ]),
            _cache[3] || (_cache[3] = _createStaticVNode("<h1 class=\"fw-bold\">Porter Ajeti</h1><div class=\"row mb-1\"><div class=\"col-10 offset-1 col-sm-8 offset-sm-2\"><h5 class=\"text-center\"><b>Software Engineer</b> @ <a href=\"https://clevergoat.com\" target=\"_blank\">clevergoat.com</a> 🐐</h5></div></div>", 2)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("a", _hoisted_12, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-brands fa-github",
                  size: "lg"
                })
              ]),
              _createElementVNode("a", _hoisted_13, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-brands fa-linkedin",
                  size: "lg"
                })
              ]),
              _createElementVNode("a", _hoisted_14, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-regular fa-file-lines",
                  size: "lg"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[1] || (_cache[1] = _createElementVNode("b", { class: "me-2" }, "☼", -1)),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("input", {
                  class: "form-check-input c-pointer order-2",
                  type: "checkbox",
                  role: "switch",
                  id: "flexSwitchCheckChecked",
                  checked: _unref(settingsState).darkModeEnabled,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(useState)().toggleTheme()))
                }, null, 8, _hoisted_17)
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("b", null, "☾", -1))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectCategories.value, (category, ci) => {
          return (_openBlock(), _createElementBlock("section", {
            key: category.name,
            class: "category color-light-black-n-dark-white pt-3 pt-sm-5 mt-5 mt-sm-5"
          }, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h2", _hoisted_20, _toDisplayString(category.name), 1),
              _createElementVNode("p", {
                class: "text-center",
                innerHTML: category.description
              }, null, 8, _hoisted_21)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.projects, (project, pi) => {
              return (_openBlock(), _createElementBlock("div", {
                key: project.name,
                class: _normalizeClass(["col-12 col-md-8 col-lg-6 col-xl-4 mt-2 mt-sm-0", { 'offset-md-1 offset-lg-2 offset-xl-3': project.side == 0, 'offset-md-3 offset-lg-4 offset-xl-5': project.side == 1 }])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["d-flex flex-column flex-sm-row align-items-center", { '': project.side == 0, 'justify-content-end': project.side == 1 }])
                }, [
                  _createElementVNode("a", {
                    href: project.link,
                    target: "_blank",
                    class: _normalizeClass(["d-flex flex-column align-items-center bg-main c-pointer my-3 color-light-black-n-dark-white text-decoration-none", { 'order-sm-2': project.side == 1 }]),
                    style: {"border-radius":"10%","border":"2px solid var(--light-black-n-dark-white)","min-width":"225px"}
                  }, [
                    _createElementVNode("img", {
                      style: {"max-width":"200px"},
                      src: project.image,
                      alt: project.name,
                      class: "p-5 pb-2"
                    }, null, 8, _hoisted_23),
                    _createElementVNode("h3", _hoisted_24, _toDisplayString(project.name), 1)
                  ], 10, _hoisted_22),
                  _createElementVNode("div", {
                    class: _normalizeClass({ 'order-sm-1': project.side == 1 })
                  }, [
                    _createElementVNode("p", _hoisted_25, _toDisplayString(project.description), 1),
                    _createElementVNode("p", {
                      class: _normalizeClass(["mx-3 d-none d-sm-block", { 'text-end': project.side == 1 }])
                    }, _toDisplayString(project.description), 3)
                  ], 2)
                ], 2)
              ], 2))
            }), 128)),
            (ci < projectCategories.value.length - 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[4] || (_cache[4] = [
                  _createElementVNode("hr", null, null, -1)
                ])))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("img", {
      src: "https://firebasestorage.googleapis.com/v0/b/ajeti-portfolio.firebasestorage.app/o/portfolio-group-outline.jpeg?alt=media",
      alt: "group-outline",
      style: {"width":"100%","max-height":"400px"}
    }, null, -1))
  ], 64))
}
}

})